import { Expose, Type } from "class-transformer";
import { IsOptional, IsString, ValidateNested } from "class-validator";
import { Permission } from "@/models/api/administration/roles/Permission";

export class DescriptionRole {
  @Expose()
  @IsOptional()
  @IsString()
  roleDescription!: string;
  @Expose()
  @Type(() => Permission)
  @ValidateNested()
  permissionDescription!: Array<Permission>;
}
